<!--
 * @Author: Gaho
 * @Date: 2024-02-29 17:42:57
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-16 17:13:57
 * @Description: 
-->
<template>
    <div class="rule-tabs">
        <div class="tabs-wrap">
            <div 
                class="tab" 
                v-for="item in tabsData" 
                :key="item.key"
                @click="$emit('handleTabChange', item)"
                :class="{ 'tab-active': item.key === currentTab }"
            >
                <IconSvgUse 
                    width="18" 
                    height="18" 
                    :use="item.icon" 
                    :use-value="item.icon"
                >
                </IconSvgUse>
                {{ $t(item.title) }}
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from "vue-i18n";
export default defineComponent({
    name: 'ruleDialogTabs',
    props: {
        currentTab: {
            type: Number,
            default: 1
        }
    },
    data(){
        return {
            $t: useI18n().t,
            tabsData: [
                {
                    title: 'rules',
                    icon: 'icon-book',
                    key: 1
                },
                {
                    title: 'payTable',
                    icon: 'icon-table-page',
                    key: 2
                },
                {
                    title: 'payLines',
                    icon: 'icon-paylines',
                    key: 3
                },
                {
                    title: 'Limits',
                    icon: 'icon-database',
                    key: 4
                }
            ],
        }
    },
    methods: {
    }
})
</script>
<style lang="scss" scoped>
.rule-tabs {
    min-width: 485px;
    
    .tabs-wrap {
        background: #1c2532;
        border-radius: 50px;
        display: flex;
        padding: 6px;
        width: 100%;

        .tab {
            border-radius: 32px;
            color: #93acd3;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            padding: 7px;
            text-align: center;
            -webkit-user-select: none;
            -moz-user-select: none;
            user-select: none;
            width: 25%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tab-active {
            background: #2283f6;
            color: #fff;
        }
    }
}
</style>